export default __webpack_public_path__ + "static/media/Rectangle 9.53a83880.png";